import { get, toNumber } from 'lodash';

import scssVariables from './variables.scss';

class Theme {
  static coerce(value) {
    const number = toNumber(value);

    return number || value;
  }

  static get(key) {
    const value = get(scssVariables, key);

    if (!value) {
      throw new Error(`Theme value for key:${key} does not exist!`);
    }

    return Theme.coerce(value);
  }
}

export default Theme;
